export const prepareStockpiles = (stockpile: any) => {
  const data = stockpile.map((item) => {
    return {
      stockpile: item.stockpile,
      distance: parseFloat(item.distance),
    };
  });

  return data;
};
